var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CashRegister",

    getDefaultProps () {
        return {"data-svgreactloader":"[[null,\"rdf\",\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"],[\"http://www.w3.org/2000/svg\",\"cc\",\"http://creativecommons.org/ns#\"],[\"http://www.w3.org/2000/svg\",\"dc\",\"http://purl.org/dc/elements/1.1/\"]]","xmlns":"http://www.w3.org/2000/svg","height":"64","width":"64","version":"1.1","viewBox":"0 0 64.000001 64.000001"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path data-svgreactloader="[[null,&quot;style&quot;,&quot;color-rendering:auto;color:#000000;isolation:auto;mix-blend-mode:normal;shape-rendering:auto;solid-color:#000000;image-rendering:auto&quot;]]" d="m18 17c-1.108 0-2 0.892-2 2v21c0 1.108 0.892 2 2 2h8v4h-3.9492c-1.108 0-2 0.892-2 2s0.892 2 2 2h20c1.108 0 2-0.892 2-2s-0.892-2-2-2h-4.051v-4h8c1.108 0 2-0.892 2-2v-21c0-1.108-0.892-2-2-2h-28zm3 4h22c0.554 0 1 0.446 1 1v15c0 0.554-0.446 1-1 1h-22c-0.554 0-1-0.446-1-1v-15c0-0.554 0.446-1 1-1zm2 2v3h3v-3h-3zm5 0v3h3v-3h-3zm5 0v3h3v-3h-3zm5 0v3h3v-3h-3zm-15 5v3h3v-3h-3zm5 0v3h3v-3h-3zm5 0v3h3v-3h-3zm5 0v8h3v-8h-3zm-15 5v3h3v-3h-3zm5 0v3h3v-3h-3zm5 0v3h3v-3h-3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/cash_register.svg